import { createInstance, OptimizelyProvider, setLogger } from '@optimizely/react-sdk'
import { createContext, useRef } from 'react'
import { captureException } from '~/lib/sentry/captureException'
import getConfig from 'next/config'
import { getUserId } from '~/lib/optimizely/getUserId'
import getIdentifyPayload from '~/utils/getIdentifyPayload'

const { publicRuntimeConfig } = getConfig()

let optimizelyInstance = null

try {
  optimizelyInstance = createInstance({
    sdkKey: publicRuntimeConfig.NEXT_PUBLIC_OPTIMIZELY_SDK_KEY,
    eventBatchSize: 10,
    eventFlushInterval: 1000,
  })

  if (process.env.NEXT_PUBLIC_OPTIMIZELY_LOGGER !== 'true') {
    setLogger(null)
  }
} catch (error) {
  captureException(error, 'Optimizely initialized')
}

export const FeatureFlagContext = createContext()

const FeatureFlagProvider = ({ children, loggedInUser }) => {
  const instance = useRef(optimizelyInstance)

  const id = getUserId()
  const attributes = getIdentifyPayload(loggedInUser)

  const user = useRef({
    id,
    attributes,
  })

  if (!instance.current) {
    return children
  }

  return (
    <OptimizelyProvider optimizely={instance.current} user={user.current}>
      <FeatureFlagContext.Provider value={instance.current}>{children}</FeatureFlagContext.Provider>
    </OptimizelyProvider>
  )
}

export default FeatureFlagProvider
